<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div
        class="row"
        v-if="data.type == 'CONTAS_A_PAGAR' || data.type == 'CONTAS_A_RECEBER'"
      >
        <div class="col-md-12 pt-0 pb-0">
          Lançamento {{ items.length > 1 ? "composto" : "" }} a ser excluído
        </div>
        <div class="col-md-12 pt-0 pb-0"><hr /></div>
        <div class="col-md-12 pt-0 pb-0">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0 text-center">
              Detalhes do lançamento
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>DATA VENCIMENTO</th>
                    <th>DESCRIÇÃO</th>
                    <th>CONTA</th>
                    <th>CATEGORIA</th>
                    <th>CENTRO DE CUSTO/LUCRO</th>
                    <th>VALOR</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in items" :key="key">
                    <td>{{ formatDate(data.due_date, false) }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ data.finance_configuration_account_name }}</td>
                    <td>{{ item.finance_configuration_category_name }}</td>
                    <td>
                      {{
                        item.finance_configuration_profit_cost_center_description
                      }}
                    </td>
                    <td
                      :class="[
                        item.spent_or_gain == 'DEBITO' && 'c-danger',
                        item.spent_or_gain == 'CREDITO' && 'c-success',
                      ]"
                    >
                      {{
                        item.spent_or_gain == "DEBITO"
                          ? formatValueNegativeOnKeyUp(String(item.value))
                          : formatValueOnKeyUp(String(item.value))
                      }}
                    </td>
                    <td>{{ data.is_paid == 1 ? "PAGO" : "AGENDADO" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          class="col-md-12 pt-0 pb-0 text-center"
          v-show="finance_launch_bills_to_pay_installments.length > 0"
        >
          <hr />
          Os itens relacionados a este lançamento estão listados abaixo, você
          pode aproveitar para excluí-los.
        </div>
        <div class="col-md-12 pt-0 pb-0"><hr /></div>
        <div
          class="col-md-12 pt-0 pb-0"
          v-show="finance_launch_bills_to_pay_installments.length > 0"
        >
          <div class="row">
            <div class="col-md-12 pt-0 pb-0 text-center">
              Selecione os outros lançamentos que deseja excluir
            </div>
            <div class="col-md-12 pt-0 text-center">
              <v-btn
                small
                class="btn-edit m-1"
                @click="handleCheckInput('TODOS')"
                >MARCAR TODOS</v-btn
              >
              <v-btn
                small
                class="btn-edit m-1"
                @click="handleCheckInput('DESMARCAR')"
                >DESMARCAR TODOS</v-btn
              >
              <v-btn
                small
                class="btn-edit m-1"
                @click="handleCheckInput('PAGOS')"
                >MARCAR PAGOS</v-btn
              >
              <v-btn
                small
                class="btn-edit m-1"
                @click="handleCheckInput('NAO_PAGOS')"
                >MARCAR NÃO PAGOS</v-btn
              >
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>DATA VENCIMENTO</th>
                    <th>DESCRIÇÃO</th>
                    <th>CONTA</th>
                    <th>CATEGORIA</th>
                    <th>CENTRO DE CUSTO/LUCRO</th>
                    <th>VALOR</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(
                      item, key
                    ) in finance_launch_bills_to_pay_installments"
                    :key="key"
                  >
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="`delete-${item.id}`"
                          @change="handleInput($event.target.checked, item.id)"
                        />
                        <label
                          class="custom-control-label"
                          :for="`delete-${item.id}`"
                        >
                          {{ formatDate(item.due_date, false) }}
                        </label>
                      </div>
                    </td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.finance_configuration_account_name }}</td>
                    <td>{{ item.categories }}</td>
                    <td>{{ item.profit_cost_center }}</td>
                    <td
                      :class="[
                        item.is_spent_or_gain == 'DEBITO' && 'c-danger',
                        item.is_spent_or_gain == 'CREDITO' && 'c-success',
                      ]"
                    >
                      {{
                        item.is_spent_or_gain == "DEBITO"
                          ? formatValueNegativeOnKeyUp(String(item.value))
                          : formatValueOnKeyUp(String(item.value))
                      }}
                    </td>
                    <td>{{ item.is_paid == 1 ? "PAGO" : "AGENDADO" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-show="repeat == 'SEMPRE'" class="col-md-12 pt-0 pb-0">
          Este lançamento possui repetição para sempre
          <hr />
        </div>
        <div v-show="repeat == 'SEMPRE'" class="col-md-12 pt-0 pb-0">
          Excluir os próximos lançamentos?
          <v-btn
            small
            :class="['m-1', !deleteEver && 'v-dark']"
            @click="handleDeleteRepetEver(false)"
          >
            <i class="fas fa-ban mr-2"></i>
            NÃO EXCLUIR OS PRÓXIMOS</v-btn
          >
          <v-btn
            small
            :class="['m-1', deleteEver && 'v-dark']"
            @click="handleDeleteRepetEver(true)"
            ><i class="fas fa-check mr-2"></i>EXCLUIR ESTE E TODOS OS
            PRÓXIMOS</v-btn
          >
        </div>
      </div>
      <div class="row" v-if="data.type == 'TRANSFERENCIA'">
        <div class="col-md-12 pt-0 pb-0">Lançamento a ser excluído</div>
        <div class="col-md-12 pt-0 pb-0"><hr /></div>
        <div class="col-md-12 pt-0 pb-0">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0 text-center">
              Detalhes da transferência
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>DATA VENCIMENTO</th>
                    <th>DESCRIÇÃO</th>
                    <th>CONTA</th>
                    <th>CATEGORIA</th>
                    <th>CENTRO DE CUSTO/LUCRO</th>
                    <th>VALOR</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in items" :key="key">
                    <td>{{ formatDate(data.due_date, false) }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.finance_configuration_account_name }}</td>
                    <td>Transferência</td>
                    <td>
                      {{
                        item.finance_configuration_profit_cost_center_description
                      }}
                    </td>
                    <td
                      :class="[
                        item.spent_or_gain == 'DEBITO' && 'c-danger',
                        item.spent_or_gain == 'CREDITO' && 'c-success',
                      ]"
                    >
                      {{
                        item.spent_or_gain == "DEBITO"
                          ? formatValueNegativeOnKeyUp(String(item.value))
                          : formatValueOnKeyUp(String(item.value))
                      }}
                    </td>
                    <td>{{ data.is_paid == 1 ? "PAGO" : "AGENDADO" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-6 pb-0">
          <v-btn class="btn-cancel mr-2" @click="handleCancel"
            ><i class="fas fa-times mr-2"></i>CANCELAR
          </v-btn>
        </div>
        <div class="col-md-6 pb-0 text-right">
          <ConfirmationDialog
            :disabled="loading"
            :loading="loading"
            headerClass="modal-header-red"
            message-title="REMOVER?"
            :message-body="`Deseja realmente excluir lançamento?`"
            open-class="btn-delete"
            open-left-icon="fa-times"
            openText="EXCLUIR"
            @yes="handleDelete()"
          />
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import {
  formatDate,
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../../../lib/format";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Delete",
  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },
  data() {
    return {
      finance_configuration_account_id: "",
      due_date: "",
      finance_configuration_document_types_id: "",
      how_many_times: "",
      document_number: "",
      competence: "",
      note: "",
      paid_in_date: "",
      periodicity: "",
      repeat: "NAO_SE_REPETE",
      is_paid: false,
      type: false,
      deleteEver: false,
      items: [],
      ids: [],
      finance_launch_bills_to_pay_installments: [],
      transfer: {},
      errors: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    handleDeleteRepetEver(deleteEver) {
      this.deleteEver = deleteEver;
    },
    handleCheckInput(type) {
      let { finance_launch_bills_to_pay_installments, ids } = this;

      if (type == "TODOS") {
        for (let item of finance_launch_bills_to_pay_installments) {
          if (!this.ids.includes(item.id)) {
            this.ids.push(item.id);
          }
          document.getElementById(`delete-${item.id}`).checked = true;
        }
      }

      if (type == "DESMARCAR") {
        for (let item of finance_launch_bills_to_pay_installments) {
          let index = ids.indexOf(item.id);

          if (index > -1) {
            ids.splice(index, 1);
          }
          document.getElementById(`delete-${item.id}`).checked = false;
        }
      }

      if (type == "PAGOS") {
        for (let item of finance_launch_bills_to_pay_installments) {
          if (item.is_paid == 1) {
            if (!this.ids.includes(item.id)) {
              this.ids.push(item.id);
            }
            document.getElementById(`delete-${item.id}`).checked = true;
          } else {
            let index = ids.indexOf(item.id);

            if (index > -1) {
              ids.splice(index, 1);
            }
            document.getElementById(`delete-${item.id}`).checked = false;
          }
        }
      }

      if (type == "NAO_PAGOS") {
        for (let item of finance_launch_bills_to_pay_installments) {
          if (item.is_paid == 0) {
            if (!this.ids.includes(item.id)) {
              this.ids.push(item.id);
            }
            document.getElementById(`delete-${item.id}`).checked = true;
          } else {
            let index = ids.indexOf(item.id);

            if (index > -1) {
              ids.splice(index, 1);
            }
            document.getElementById(`delete-${item.id}`).checked = false;
          }
        }
      }
    },
    handleInput(checked, id) {
      if (checked) {
        if (!this.ids.includes(id)) {
          this.ids.push(id);
        }
      } else {
        let { ids } = this;

        let index = ids.indexOf(id);

        if (index > -1) {
          ids.splice(index, 1);
        }
      }
    },
    async retrieve() {
      let { data } = this;

      this.ids = [data.id];

      this.finance_configuration_account_id =
        data.finance_configuration_account_id;
      this.due_date = data.due_date
        ? moment(data.due_date).format("YYYY-MM-DD")
        : "";
      this.finance_configuration_document_types_id =
        data.finance_configuration_document_types_id;
      this.how_many_times = data.how_many_times;
      this.document_number = data.document_number;
      this.competence = data.competence;
      this.paid_in_date = data.paid_in_date
        ? moment(data.paid_in_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      this.competence = data.competence
        ? moment(data.competence).format("YYYY-MM-DD")
        : "";
      this.periodicity = data.periodicity;
      this.note = data.note ? data.note : "";
      this.is_paid = data.is_paid == 1 ? true : false;

      this.repeat = data.is_repeat ? data.is_repeat : "NAO_SE_REPETE";
      this.type = data.type;

      for (let item of data.items) {
        if (item.spent_or_gain == "DEBITO") {
          item.value = formatValueNegativeOnKeyUp(item.value);
        } else {
          item.value = formatValueOnKeyUp(item.value);
        }

        item.finance_configuration_account_name =
          data.finance_configuration_account_name;
        this.items.push(item);
      }

      if (data.is_repeat != "SEMPRE") {
        await this.getFinanceLaunchBillsToPayInstallments();
      }

      if (data.type == "TRANSFERENCIA") {
        await this.getTransfer();
      }
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async getFinanceLaunchBillsToPayInstallments() {
      try {
        this.loading = true;

        let {
          data: { id, finance_launch_bills_to_pay_id },
        } = this;

        let params = { id, finance_launch_bills_to_pay_id };

        const response = await api.get(
          "/rest-home/financial/launch/finance-launch-bills-to-pay-installments",
          { params }
        );

        const { error, data } = response.data;

        if (!error) {
          this.finance_launch_bills_to_pay_installments = data;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getTransfer() {
      try {
        this.loading = true;

        let {
          data: { id, finance_launch_bills_to_pay_id },
        } = this;

        let params = { id, finance_launch_bills_to_pay_id };

        const response = await api.get(
          "/rest-home/financial/launch/finance-launch-bills-to-pay-transfer",
          { params }
        );

        const { error, data } = response.data;

        if (!error) {
          data.value = formatValueOnKeyUp(String(data.value));
          this.items.push(data);
          this.ids.push(data.id);
          this.transfer = data;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async handleDelete() {
      try {
        this.loading = true;

        const {
          ids,
          data: { finance_launch_bills_to_pay_id, type },
          repeat,
          deleteEver,
        } = this;

        let data = {
          ids,
          finance_launch_bills_to_pay_id,
          repeat,
          deleteEver,
          type,
        };

        const response = await api.delete("/rest-home/financial/launch/pay", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>